export default __webpack_public_path__ + "static/media/100_38984.80207497.jpg";